<template>
	<div>
		<header class="admin-head">
			<nav class="container">
				<div class="row">
					<div class="col-xs-5 top-nav-container">
						<router-link
							class="btn btn-clear btn-sm"
							role="button"
							to="/"
						>
							<i class="material-icons btn-icon-lg">home</i>
						</router-link>
						<!-- Member dropdown -->
						<b-dropdown class="dropdown btn-group">
							<button
								class="btn btn-clear btn-sm dropdown-toggle"
								type="button"
								id="profile"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="true"
							>
								<i class="material-icons btn-icon-lg">person</i>
							</button>
							<template slot="dropdown" class="dropdown-menu">
								<li class="dropdown-title">{{ name }}</li>
								<li><router-link to="/profile" role="button">My profile</router-link></li>
								<li><router-link to="/" role="button">Front-end</router-link></li>
								<li @click="logout"><router-link to="/login">Logout</router-link></li>
							</template>
						</b-dropdown>
					</div>
					<div class="col-xs-7 logo-container-head visible-xs">
						<router-link to="/">
							<img
								class="img-responsive logo-head"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</router-link>
					</div>
					<div class="col-xs-7 logo-container-head hidden-xs">
						<router-link to="/">
							<img
								class="img-responsive logo-head"
								src="@/assets/images/iadsa-logo.svg"
								alt="IADSA"
							>
						</router-link>
					</div>
					<div class="col-xs-12">
						<router-link to="/admin">
							<div class="admin-head-text">ADMIN</div>
						</router-link>
					</div>
				</div>
			</nav>
		</header>
		<div class="header-border-admin"/>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			default: null
		}
	},
	methods: {
		logout() {
			this.$emit('logout');
		}
	}
};
</script>
